import "url-search-params-polyfill";
import "intersection-observer";
import { ResizeObserver } from "@juggle/resize-observer";
import "@formatjs/intl-listformat/polyfill";
import "@formatjs/intl-listformat/locale-data/en";
import "array.prototype.at/auto";

window.ResizeObserver = window.ResizeObserver || ResizeObserver;
